import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme/semanticTokens';
import { Typography } from '../../../Typography';
import { getInputTextColor } from './inputFieldStatus.styles';

export interface InputHelpTextProps {
  className?: string;
  text: string;
  hasError?: boolean;
}

const StyledHelpText = styled(Typography)<{ $hasError: boolean }>`
  color: ${({ $hasError }) => getInputTextColor($hasError)};
  margin-bottom: ${theme.dime.spacing.s};
`;

export const InputHelpText: React.FC<InputHelpTextProps> = ({
  className,
  text,
  hasError = false
}) => (
  <StyledHelpText className={className} variant="body1" $hasError={hasError}>
    {text}
  </StyledHelpText>
);
